export default {
   FUSIONCHARTS_DATASOURCE: state => key => state[key],
};
